export default __webpack_public_path__ + "static/media/Table.3d0e7137.png";